import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Nav, Button } from 'react-bootstrap';
import { Gem, Calculator } from 'lucide-react';

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
    window.location.reload();
  };

  return (
    <div className="admin-layout" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <div 
        className="sidebar bg-white border-end shadow-sm" 
        style={{ width: '250px', position: 'fixed', height: '100vh', top: '76px', left: 0, zIndex: 100 }}
      >
        <div className="p-4 d-flex flex-column h-100">
          <h5 className="fw-bold mb-4" style={{ color: 'var(--color-primary)', fontFamily: 'var(--font-serif)' }}>
            Admin Panel
          </h5>
          <Nav className="flex-column gap-2 mb-auto">
            <NavLink 
              to="/dashboard" 
              end
              className={({ isActive }) => 
                `nav-link p-3 rounded-3 d-flex align-items-center gap-3 ${isActive ? 'bg-primary text-white' : 'text-dark hover-bg-light'}`
              }
              style={({ isActive }) => isActive ? { backgroundColor: 'var(--color-primary)' } : {}}
            >
              <Gem size={20} />
              <span className="fw-medium">Diamonds</span>
            </NavLink>
            <NavLink 
              to="/dashboard/calculate-cost" 
              className={({ isActive }) => 
                `nav-link p-3 rounded-3 d-flex align-items-center gap-3 ${isActive ? 'bg-primary text-white' : 'text-dark hover-bg-light'}`
              }
              style={({ isActive }) => isActive ? { backgroundColor: 'var(--color-primary)' } : {}}
            >
              <Calculator size={20} />
              <span className="fw-medium">Calculate Cost</span>
            </NavLink>
          </Nav>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="main-content flex-grow-1" style={{ marginLeft: '250px', backgroundColor: '#f8f9fa' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
